import { GLOBAL_NAME } from '../constants/Globals';
import { UPDATE_THIRD_PARTY_SUBJECT } from '../constants/EventListeners';
export function triggerHostMessageUpdateThirdPartySubject(data) {
  if (window[GLOBAL_NAME].triggerEvent) {
    window.hsCalling.triggerEvent({
      event: UPDATE_THIRD_PARTY_SUBJECT,
      data
    });
  }
}